export default "__VITE_ASSET__CPaIk2VJ__"